import { Component, inject } from '@angular/core';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

export interface ConfirmCancelDialogData {
  title: string;
  content: string;
  confirmLabel?: string;
  icon?: string;
}

@Component({
  selector: 'app-confirm-cancel-dialog',
  imports: [MatDialogModule, MatButtonModule, MatIconModule],
  templateUrl: './confirm-cancel-dialog.html',
  styleUrl: './confirm-cancel-dialog.css',
})
export class ConfirmCancelDialog {
  private dialogRef = inject(MatDialogRef<ConfirmCancelDialog>);
  data = inject<ConfirmCancelDialogData>(MAT_DIALOG_DATA);
  get title(): string {
    return this.data.title;
  }

  get content(): string {
    return this.data.content;
  }

  get confirmLabel(): string {
    return this.data.confirmLabel ?? 'Confirm';
  }

  get icon(): string {
    return this.data.icon ?? 'help_outline';
  }

  cancel(): void {
    this.dialogRef.close(false);
  }

  confirm(): void {
    this.dialogRef.close(true);
  }
}
